import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { prescriptionQKeys } from "@hooks/queries/prescription/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface MutationProps {
  formData: FormData;
  prescriptionId: string;
  patientId: string;
}

export const useUpdatePrescription = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ formData, prescriptionId }: MutationProps) => {
      return api.patch(`prescription/${prescriptionId}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: (_, variables) => {
      showSuccessNotification({
        title: "success",
        message: "update-prescription-success",
      });
      queryClient.invalidateQueries({
        queryKey: prescriptionQKeys.patient(variables.patientId),
      });
    },

    onError: (res: any) => {
      console.error("[From Update Prescription]", res);
      handleErrors(res, "mutation");
    },
  });
};
